import { convert } from 'jcampconverter';
import { Analysis } from '../Analysis';
/**
 * Creates a new Analysis from a JCAMP string
 * @param {string} jcamp - String containing the JCAMP data
 * @param {object} [options={}]
 * @param {object} [options.id=Math.random()]
 * @param {string} [options.label=options.id] human redeable label
 * @param {string} [options.spectrumCallback] a callback to apply on variables when creating spectrum
 * @return {Analysis} - New class element with the given data
 */
export function fromJcamp(jcamp, options = {}) {
    let analysis = new Analysis(options);
    addJcamp(analysis, jcamp);
    return analysis;
}
function addJcamp(analysis, jcamp) {
    let converted = convert(jcamp, {
        keepRecordsRegExp: /.*/,
    });
    for (let entry of converted.flatten) {
        let currentSpectrum = entry.spectra[0];
        // we ensure variables
        if (!currentSpectrum.variables) {
            const variables = {};
            currentSpectrum.variables = variables;
            variables.x = {
                label: currentSpectrum.xUnits,
                symbol: 'X',
                data: currentSpectrum.data.x || currentSpectrum.data.X,
            };
            variables.y = {
                label: currentSpectrum.yUnits,
                symbol: 'Y',
                data: currentSpectrum.data.y || currentSpectrum.data.Y,
            };
        }
        else {
            for (let key in currentSpectrum.variables) {
                const variable = currentSpectrum.variables[key];
                if (variable.label)
                    continue;
                variable.label = variable.name || variable.symbol || key;
                if (variable.units && !variable.label.includes(variable.units)) {
                    variable.label += ` [${variable.units}]`;
                }
            }
        }
        analysis.pushSpectrum(currentSpectrum.variables, {
            dataType: entry.dataType,
            title: entry.title,
            meta: entry.meta,
        });
    }
}
//# sourceMappingURL=data:application/json;base64,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